export default {
  'INBOUND-PRODUCT-DETAIL-BTN': {
    key: 'inbound-product-detail-btn',
    label: '预检-商品详情按钮'
  },
  'INBOUND-RETRY-FLOW-BTN': {
    key: 'inbound-retry-flow-btn',
    label: '预检-重试预跑流向按钮'
  },
  'INBOUND-PRINT-BTN': {
    key: 'inbound-print-btn',
    label: '预检-打印按钮'
  },
  'INBOUND-PRINT-BTN-CLICK': {
    key: 'inbound-print-btn-click',
    label: '预检-打印按钮-点击'
  },
  'INBOUND-SCAN-INBOUNDNO-BTN': {
    key: 'inbound-scan-inboundno-btn',
    label: '预检-扫描入库单号'
  },
  'INBOUND-SCAN-BOX-BTN': {
    key: 'inbound-scan-box-btn',
    label: '预检-扫描箱号'
  },
  'INBOUND-SCAN-CONTAINER-BTN': {
    key: 'inbound-scan-container-btn',
    label: '预检-扫描容器号'
  },
  'INBOUND-SCAN-BARCODE-BTN': {
    key: 'inbound-scan-barcode-btn',
    label: '预检-扫描商品条码'
  },
  'INBOUND-CONTAINER-FINISH-BTN': {
    key: 'inbound-container-finish-btn',
    label: '预检-容器完验'
  },
  'INBOUND-ORDER-FINISH-BTN': {
    key: 'inbound-order-finish-btn',
    label: '预检-整单完验'
  },
  'INBOUND-NEWGOODS-BTN': {
    key: 'inbound-newgoods-btn',
    label: '预检-新品采集弹窗'
  },
  'INBOUND-NEWGOODS-SAVE-BTN': {
    key: 'inbound-newgoods-save-btn',
    label: '预检-新品采集弹窗-保存'
  },
  'INBOUND-BOX-PAGE':{
    key: 'inbound-box-page',
    label: '预检-扫描箱号页面-进入'
  },
  'INBOUND-PRODUCT-OPERATION':{
    key: 'inbound-product-operation',
    label: '预检-商品操作-进入'
  },
  'INBOUND-INPUT-ENTER':{
    key: 'inbound-input-enter',
    label: '预检-数量输入框-进入'
  },
  'INBOUND-CONTAINER-FINISH-SUCCESS':{
    key: 'inbound-container-finish-success',
    label: '预检-容器完验-成功'
  },
  'INBOUND-ORDER-FINISH-SUCCESS': {
    key: 'inbound-order-finish-success',
    label: '预检-整单完验-成功'
  }
}